import { combineReducers } from "redux";
import user from "./user";
import app from "./app";
import supplierpayments from "./supplierpayments";
import orders from "./orders";
import notifications from "./notifications";
import agentsPayments from "./agentsPayments";
import ridersPayments from "./ridersPayments";

const rootReducer = combineReducers({
  user,
  app,
  supplierpayments,
  notifications,
  orders,
  agentsPayments,
  ridersPayments,
});

export default rootReducer;
